"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convertToHeadAndTailActions = (flattenedState) => {
    if (!flattenedState) {
        return {
            headAction: {},
            tailAction: {},
        };
    }
    const { headServiceId, headActionId, headActionType, headActionLabel, tailServiceId, tailActionId, tailActionType, tailActionLabel, } = flattenedState;
    const headAction = {
        serviceId: headServiceId,
        id: headActionId,
        typeOf: headActionType,
        label: headActionLabel,
    };
    const tailAction = {
        serviceId: tailServiceId,
        id: tailActionId,
        typeOf: tailActionType,
        label: tailActionLabel,
    };
    return {
        headAction,
        tailAction,
    };
};
exports.default = convertToHeadAndTailActions;
